import React, { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import ProposalsTab from './ProposalsTab';
import PurchaseOrderGenerator from './PurchaseOrderGenerator';
import { TabBtn } from './ui';

export function ProposalsAndPOs(p){
  var ts=useState("proposals");var subTab=ts[0];var setSubTab=ts[1];
  var subTabs=["Proposals","Purchase Orders"];
  return (
    <div>
      <div style={{display:"flex",gap:2,borderBottom:"1px solid #e0e0e0",marginBottom:24}}>
        {subTabs.map(function(t,i){return <TabBtn key={t} label={t} active={subTab===(i===0?"proposals":"pos")} onClick={function(){setSubTab(i===0?"proposals":"pos");}} />;})}
      </div>
      {subTab==="proposals"&&<ProposalsTab items={p.items} projects={p.projects} proposals={p.proposals} setProposals={p.setProposals} onUpdateItem={p.onUpdateItem} />}
      {subTab==="pos"&&<PurchaseOrderGenerator items={p.items} projects={p.projects} vendors={p.vendors} onUpdateItem={p.onUpdateItem} />}
    </div>
  );
}


// ── AUTO BACKUP EXPORT ────────────────────────────────────────────────────
export function generateFullCSV(items) {
  var hd = ["Item","Product Name","Schedule","Project","Room","Room #","Tag","Vendor","Qty","Qty Type",
    "Status","Net Price","Client Price","Lead Time","PO Number","Sidemark","Notes","Installer",
    "Received","Installed","Source URL","Date Added","Specs"];
  var rows = (items||[]).filter(function(it){return !it.parentId;}).map(function(it){
    return [
      it.item||"", it.productName||"", it.schedule||"", it.project||"",
      it.roomName||"", it.roomNumber||"", it.tag||"", it.vendor||"",
      it.qty||"", it.qtyType||"", it.status||"", it.netPrice||"",
      it.clientPrice||"", it.leadTime||"", it.poNumber||"", it.sidemark||"",
      (it.notes||"").replace(/\n/g," "), it.installer||"",
      it.orderPlacedDate||"", it.receivedDate||"", it.sourceUrl||"",
      it.date||"", it.specs?JSON.stringify(it.specs):"",
    ];
  });
  return [hd].concat(rows).map(function(r){
    return r.map(function(c){return '"'+String(c||"").replace(/"/g,'\"')+ '"';}).join(",");
  }).join("\n");
}

export function downloadCSV(csv, filename) {
  var a = document.createElement("a");
  a.href = URL.createObjectURL(new Blob([csv], {type:"text/csv"}));
  a.download = filename;
  a.click();
  URL.revokeObjectURL(a.href);
}


// ── IMAGE EXPORT AS ZIP ───────────────────────────────────────────────────────
async function exportImagesAsZip(items, projectFilter, onProgress) {
  if (!window.JSZip) {
    await new Promise((resolve, reject) => {
      var s = document.createElement('script');
      s.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
      s.onload = resolve; s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  var zip = new window.JSZip();
  var filtered = items.filter(function(it) {
    if (it.parentId) return false;
    if (projectFilter && it.project !== projectFilter) return false;
    return it.images && it.images.length > 0;
  });
  if (filtered.length === 0) { alert('No items with images found.'); return; }
  var total = filtered.reduce(function(s,it){ return s+(it.images||[]).length; }, 0);
  var done = 0;
  for (var i = 0; i < filtered.length; i++) {
    var item = filtered[i];
    var images = item.images || [];
    var proj = (item.project||'No Project').replace(/[\/\\:*?"<>|]/g,'-');
    var room = (item.roomName||'No Room').replace(/[\/\\:*?"<>|]/g,'-');
    var folder = zip.folder(proj).folder(room);
    for (var j = 0; j < images.length; j++) {
      var img = images[j];
      if (!img.url) continue;
      try {
        var res = await fetch(img.url);
        var blob = await res.blob();
        var ext = (img.url.split('.').pop().split('?')[0]||'jpg').toLowerCase();
        var prod = (item.productName||item.item||'item').replace(/[\/\\:*?"<>|]/g,'-').slice(0,40);
        var vdr  = (item.vendor||'').replace(/[\/\\:*?"<>|]/g,'-').slice(0,20);
        var hero = j===(item.heroIndex||0)?'_HERO':'';
        folder.file(String(j+1).padStart(2,'0')+'_'+prod+'_'+vdr+hero+'.'+ext, blob);
        done++;
        if (onProgress) onProgress(done, total);
      } catch(e) { console.warn('Image fetch failed:', img.url); }
    }
  }
  var zipBlob = await zip.generateAsync({type:'blob', compression:'DEFLATE'});
  var url = URL.createObjectURL(zipBlob);
  var a = document.createElement('a');
  a.href = url;
  var pname = projectFilter ? projectFilter.replace(/[^a-zA-Z0-9-]/g,'_') : 'AllProjects';
  a.download = 'CimonStarr_Images_'+pname+'_'+new Date().toISOString().slice(0,10)+'.zip';
  a.click();
  URL.revokeObjectURL(url);
  return {downloaded: done, total};
}


// ── ITEM SHEET GENERATOR ──────────────────────────────────────────────────────


// ── IMAGE EXPORT PANEL ───────────────────────────────────────────────────────
export function ImageExportPanel(p) {
  var ps = useState(''); var projFilter = ps[0]; var setProjFilter = ps[1];
  var es = useState(false); var exporting = es[0]; var setExporting = es[1];
  var ms = useState(''); var msg = ms[0]; var setMsg = ms[1];
  var pr = useState(null); var progress = pr[0]; var setProgress = pr[1];

  var projectNames = [...new Set((p.items||[]).filter(function(it){return it.images&&it.images.length>0;}).map(function(it){return it.project;}).filter(Boolean))].sort();
  var itemsWithImages = (p.items||[]).filter(function(it){return !it.parentId&&it.images&&it.images.length>0;});
  var filtered = projFilter ? itemsWithImages.filter(function(it){return it.project===projFilter;}) : itemsWithImages;
  var totalImages = filtered.reduce(function(s,it){return s+(it.images||[]).length;},0);

  async function doExport() {
    setExporting(true); setMsg(''); setProgress(null);
    try {
      var result = await exportImagesAsZip(p.items, projFilter||null, function(done, total) {
        setProgress({done, total});
      });
      setMsg('✓ Downloaded '+result.downloaded+' images in ZIP');
    } catch(e) {
      setMsg('Error: '+e.message);
    }
    setExporting(false); setProgress(null);
  }

  return (
    <div>
      <div style={{display:'flex',gap:12,alignItems:'center',flexWrap:'wrap'}}>
        <select value={projFilter} onChange={function(e){setProjFilter(e.target.value);}} style={{padding:'7px 12px',border:'1px solid #c8e6c9',borderRadius:6,fontSize:12,background:'#fff',minWidth:160}}>
          <option value=''>All projects</option>
          {projectNames.map(function(pn){return <option key={pn} value={pn}>{pn}</option>;})}
        </select>
        <div style={{fontSize:12,color:'#888'}}>{filtered.length} items · {totalImages} images</div>
        <button onClick={doExport} disabled={exporting||totalImages===0} style={{padding:'8px 20px',background:'#2e7d32',color:'#fff',border:'none',borderRadius:7,fontSize:13,fontWeight:600,cursor:exporting||totalImages===0?'not-allowed':'pointer',opacity:exporting||totalImages===0?0.6:1}}>
          {exporting?'Downloading…':'⬇ Export ZIP'}
        </button>
      </div>
      {progress&&<div style={{marginTop:8,fontSize:12,color:'#2e7d32'}}>Downloading {progress.done} of {progress.total} images…</div>}
      {msg&&<div style={{marginTop:8,fontSize:12,color:msg.startsWith('✓')?'#2e7d32':'#c62828'}}>{msg}</div>}
      <div style={{fontSize:10,color:'#aaa',marginTop:8}}>
        ZIP organized as: Project / Room / 01_ProductName_Vendor_HERO.jpg
      </div>
    </div>
  );
}


// ── PRESENTATION SPEC EXPORT ──────────────────────────────────────────────────
export async function generatePresentationSpec(item, selectedImageIndex, showPricing, componentPrices) {
  var netPrice = parseFloat(String(item.netPrice||'').replace(/[$,]/g,''))||0;
  var markup   = parseFloat(String(item.markupPct||30))||30;
  var clientPrice = netPrice > 0 ? (netPrice * (1 + markup/100)) : 0;
  var payload = {
    project:      item.project||'',
    product_name: item.productName||item.item||'',
    item:         item.item||'',
    description:  item.specNotes||'',
    manufacturer: item.manufacturer||'',
    model:        item.model||'',
    finish:       item.finish||item.specs&&item.specs.finish||'',
    dimensions:   item.dimensions||item.specs&&item.specs.dimensions||'',
    lead_time:    item.leadTime||'',
    client_price: clientPrice > 0 ? clientPrice : '',
    qty:          item.qty||'1',
    qty_type:     item.qtyType||'Each',
    show_pricing: showPricing||false,
    component_prices: componentPrices,
    hero_index:   selectedImageIndex||item.heroIndex||0,
    image_url:    (item.images&&item.images.length>0)
                    ? item.images[selectedImageIndex||item.heroIndex||0].url
                    : (item.imageUrl||''),
    images:       item.images||[],
  };
  var res = await fetch('/api/generate-presentation-spec', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify(payload)
  });
  if (!res.ok) throw new Error('API error ' + res.status);
  var blob = await res.blob();
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  var proj = (item.project||'Project').replace(/[^a-zA-Z0-9]/g,'_');
  var name = (item.productName||item.item||'Item').replace(/[^a-zA-Z0-9]/g,'_');
  var roomPart = item.roomNumber ? item.roomNumber+'_' : '';
  a.download = roomPart+proj+'_'+name+'.zip';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}


// ── INTERNAL TEAR SHEET BUTTON ───────────────────────────────────────────────
export async function generateItemSheetPdf(item, selectedImageIndex, shipTo, vendors, quotePdfs, workroomMode) {
  var netPrice   = parseFloat(String(item.netPrice||'').replace(/[$,]/g,''))||0;
  var markup     = parseFloat(String(item.markupPct||30))||30;
  var clientPrice = netPrice > 0 ? (netPrice * (1 + markup/100)) : 0;
  // Build children ship-to list for the PDF
  function resolveChildShipTo(child) {
    if(child.shipToAddress)return child.shipToAddress;
    if(child.shipToVendorId==='install_on_site')return 'Install on site';
    if(child.shipToVendorId && vendors) {
      var v = (vendors||[]).find(function(v){ return String(v.id)===String(child.shipToVendorId); });
      if(v) {
        var parts = [v.address, v.address2, [v.city, v.state, v.zip].filter(Boolean).join(' ')].filter(Boolean);
        return [v.name].concat(parts).filter(Boolean).join('\n');
      }
    }
    var com = child.com||{};
    return [com.shipToName, com.shipToAddress, [com.shipToCity, com.shipToState, com.shipToZip].filter(Boolean).join(', ')].filter(Boolean).join(', ');
  }
  var childrenShipTo = (item.children||[]).filter(function(c){ return c.shipToVendorId || c.shipToAddress || (c.com&&c.com.shipToAddress); }).map(function(c){
    return { child_type: c.childType||'Component', item: c.item||'', ship_to: resolveChildShipTo(c) };
  });
  var vendorObj = (vendors||[]).find(function(v){ return v.name===item.vendor; });
  var payload = {
    project:      item.project||'',
    product_name: item.productName||item.item||'',
    item:         item.item||'',
    description:  item.specNotes||'',
    manufacturer: item.manufacturer||'',
    vendor:       item.vendor||'',
    vendor_contact: item.vendorContactName || (vendorObj&&vendorObj.contact||''),
    vendor_email:   item.vendorContactEmail || (vendorObj&&vendorObj.email||''),
    model:        item.model||'',
    finish:       item.finish||item.specs&&item.specs.finish||'',
    dimensions:   item.dimensions||item.specs&&item.specs.dimensions||'',
    date_added:   item.date||'',
    lead_time:    item.leadTime||'',
    ship_to:      shipTo||'',
    source_url:   item.sourceUrl||'',
    net_price:    netPrice > 0 ? netPrice : '',
    client_price: clientPrice > 0 ? clientPrice : '',
    markup_pct:   markup,
    fee_markup_pct: itemFeeMarkupPct(item),
    deposit_pct:  item.depositPct||'',
    fees:         item.fees||{},
    qty:          item.qty||'1',
    status:       item.status||'',
    notes:        item.notes||'',
    status_notes: item.statusNotes||'',
    wr_entries:   item.wrEntries||[],
    po_number:    item.poNumber||'',
    installer:          item.installer||'',
    child_type:         item.childType||'',
    schedule:           item.schedule||'',
    room_number:        item.roomNumber||'',
    room_name:          item.roomName||'',
    specs:              item.specs||{},
    materials_to_workroom: item.materialsToWorkroom||[],
    hero_index:         selectedImageIndex||item.heroIndex||0,
    image_url:          (item.images&&item.images.length>0)
                          ? item.images[selectedImageIndex||item.heroIndex||0].url
                          : (item.imageUrl||''),
    images:             item.images||[],
    children_ship_to:   childrenShipTo,
    components: (function(){var COMP_TYPES=['Fabric','Trim','Workroom','Hardware','Roller Shades','COM/COL Fabric'];var self=COMP_TYPES.indexOf(item.childType||'')>=0?[{child_type:item.childType,item:item.item||'',vendor:item.vendor||'',qty:item.qty||'',qty_type:item.qtyType||'',status:item.status||'',net_price:item.netPrice||'',specs:item.specs||{}}]:[];var kids=(item.children||[]).filter(function(c){return c.childType!=='Bulb';}).map(function(c){return {child_type:c.childType||'',item:c.item||'',vendor:c.vendor||'',qty:c.qty||'',qty_type:c.qtyType||'',status:c.status||'',net_price:c.netPrice||'',specs:c.specs||{}};});return self.concat(kids);})(),
    quote_pdfs:         quotePdfs||[],
    workroom_mode:      workroomMode||false,
  };
  var res = await fetch('/api/generate-item-sheet', {
    method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify(payload)
  });
  if (!res.ok) throw new Error('API error ' + res.status);
  var blob = await res.blob();
  var url = URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  var proj = (item.project||'Project').replace(/[^a-zA-Z0-9]/g,'_');
  var name = (item.productName||item.item||'Item').replace(/[^a-zA-Z0-9]/g,'_');
  var roomPart = item.roomNumber ? item.roomNumber+'_' : '';
  a.download = roomPart+proj+'_'+name+'_'+(workroomMode?'workroom_order':'internal_tear_sheet')+'.zip';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

export function ItemSheetButton(p) {
  var item = p.item;
  var images = item.images||[];
  var heroIdx = item.heroIndex||0;

  // Resolve ship-to: item-level vendor picker first, then project receiver
  function resolveShipTo() {
    function fmtVendor(v) {
      var parts = [v.address, v.address2, [v.city, v.state, v.zip].filter(Boolean).join(' ')].filter(Boolean);
      return [v.name].concat(parts).filter(Boolean).join('\n');
    }
    if(item.shipToVendorId) {
      var stv = null;
      (p.vendors||[]).forEach(function(v){ if(String(v.id)===String(item.shipToVendorId)) stv=v; });
      if(stv) return fmtVendor(stv);
    }
    var proj = null;
    (p.projects||[]).forEach(function(pr){ if(pr.label===item.project) proj=pr; });
    if(!proj||!proj.receiverId) return '';
    var receiver = null;
    (p.vendors||[]).forEach(function(v){ if(String(v.id)===String(proj.receiverId)) receiver=v; });
    if(!receiver) return '';
    return fmtVendor(receiver);
  }

  var os = useState(false); var open = os[0]; var setOpen = os[1];
  var hs = useState(heroIdx); var specImgIdx = hs[0]; var setSpecImgIdx = hs[1];
  var ss = useState(images.map(function(_,i){return i;}));
  var selectedImgs = ss[0]; var setSelectedImgs = ss[1];
  var ls = useState(false); var loading = ls[0]; var setLoading = ls[1];
  var es = useState(''); var err = es[0]; var setErr = es[1];
  var qds = useState([]); var quoteDocs = qds[0]; var setQuoteDocs = qds[1];
  var iqs = useState(false); var includeQuote = iqs[0]; var setIncludeQuote = iqs[1];

  useEffect(function(){
    if(open && item.id){
      supabase.from('item_documents').select('*').eq('item_id',item.id).in('doc_type',['Quote','Quote Request']).order('created_at',{ascending:false})
        .then(function(r){ setQuoteDocs(r.data||[]); });
    }
  },[open]);

  function toggleImg(i) {
    setSelectedImgs(function(prev) {
      if (prev.indexOf(i) >= 0) {
        if (i === specImgIdx) return prev;
        return prev.filter(function(x){return x!==i;});
      }
      return prev.concat([i]).sort(function(a,b){return a-b;});
    });
  }

  function setHero(i) {
    setSpecImgIdx(i);
    setSelectedImgs(function(prev){
      if (prev.indexOf(i) >= 0) return prev;
      return prev.concat([i]).sort(function(a,b){return a-b;});
    });
  }

  async function doExport() {
    setLoading(true); setErr('');
    try {
      var filteredImages = selectedImgs.map(function(i){ return images[i]; }).filter(Boolean);
      var newHeroIdx = selectedImgs.indexOf(specImgIdx);
      var quotePdfUrls = [];
      if(includeQuote && quoteDocs.length > 0){
        quotePdfUrls = await Promise.all(quoteDocs.map(async function(d){
          var docPath = d.path || d.file_path;
          if(docPath){
            var sr = await supabase.storage.from('item-documents').createSignedUrl(docPath, 120);
            if(sr.data && sr.data.signedUrl) return sr.data.signedUrl;
          }
          return d.url || '';
        }));
        quotePdfUrls = quotePdfUrls.filter(Boolean);
      }
      var dbChildren = [];
      if(item.id){
        var cr = await supabase.from('items').select('id,child_type,item,vendor,specs').eq('parent_id', item.id).is('deleted_at', null);
        if(!cr.error){
          dbChildren = (cr.data||[]).map(function(r){
            var sp=r.specs;if(typeof sp==='string'){try{sp=JSON.parse(sp);}catch(e){sp={};}}sp=sp||{};
            return {id:r.id,childType:r.child_type||'',item:r.item||'',vendor:r.vendor||'',specs:sp};
          });
        }
      }
      var dbChildTypes={}; dbChildren.forEach(function(c){if(c.childType)dbChildTypes[c.childType]=true;});
      var inMemChildren=(item.children||[]).filter(function(c){return c.childType&&!dbChildTypes[c.childType];});
      var mergedChildren=dbChildren.concat(inMemChildren);
      var materialsToWorkroom = [];
      if(item.childType==='Workroom' && item.parentId){
        var mr = await supabase.from('items').select('item,vendor,specs,qty,qty_type').eq('parent_id', item.parentId).in('child_type', ['Fabric','Trim','COM/COL Fabric']).is('deleted_at', null);
        if(!mr.error){
          materialsToWorkroom = (mr.data||[]).map(function(r){
            var sp=r.specs;if(typeof sp==='string'){try{sp=JSON.parse(sp);}catch(e){sp={};}}sp=sp||{};
            var yardage=(sp.yardage||r.qty||'');
            var qtyType=(sp.qtyType||r.qty_type||'');
            return {name:r.item||'',vendor:r.vendor||'',yardage:yardage?(yardage+(qtyType?' '+qtyType:'')):''};
          });
        }
      }
      await generateItemSheetPdf(
        Object.assign({}, item, {images: filteredImages, children: mergedChildren, materialsToWorkroom: materialsToWorkroom}),
        Math.max(0, newHeroIdx),
        resolveShipTo(),
        p.vendors,
        quotePdfUrls
      );
      setOpen(false);
    } catch(e) { setErr(e.message); }
    setLoading(false);
  }

  return (
    <div style={{position:'relative',display:'inline-block'}}>
      <button onClick={function(){setOpen(!open);}} style={{padding:'4px 12px',background:'#fff',border:'1px solid #ddd',borderRadius:6,fontSize:11,cursor:'pointer'}}>
        ⬇ Internal Tear Sheet
      </button>
      {open&&(
        <div style={{position:'absolute',top:'100%',right:0,marginTop:4,background:'#fff',border:'1px solid #e0e0e0',borderRadius:8,padding:16,zIndex:200,width:290,boxShadow:'0 4px 16px rgba(0,0,0,0.12)'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
            <div style={{fontSize:11,fontWeight:700,color:'#333'}}>Export Internal Tear Sheet</div>
            <button onClick={function(){setOpen(false);setErr('');}} style={{background:'none',border:'none',fontSize:16,color:'#aaa',cursor:'pointer',lineHeight:1}}>×</button>
          </div>
          {images.length > 0
            ? (
              <div style={{marginBottom:14}}>
                <div style={{fontSize:10,fontWeight:700,color:'#888',marginBottom:6,letterSpacing:'0.5px',textTransform:'uppercase'}}>
                  Images — check to include in ZIP, click star for spec
                </div>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  {images.map(function(img, i) {
                    var isSelected = selectedImgs.indexOf(i) >= 0;
                    var isHero = i === specImgIdx;
                    return (
                      <div key={i} style={{position:'relative',flexShrink:0}}>
                        <div style={{width:56,height:56,borderRadius:4,overflow:'hidden',border:isHero?'2px solid #1a1a1a':isSelected?'2px solid #90caf9':'2px solid #e0e0e0',opacity:isSelected?1:0.4,cursor:'pointer'}} onClick={function(){toggleImg(i);}}>
                          <img src={img.url||''} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}} />
                        </div>
                        <div style={{position:'absolute',bottom:2,left:2,background:isSelected?'#1a56db':'#fff',border:'1.5px solid '+(isSelected?'#1a56db':'#ccc'),borderRadius:3,width:14,height:14,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}} onClick={function(e){e.stopPropagation();toggleImg(i);}}>
                          {isSelected&&<span style={{color:'#fff',fontSize:9,lineHeight:1}}>✓</span>}
                        </div>
                        <div style={{position:'absolute',top:2,right:2,background:isHero?'#1a1a1a':'rgba(0,0,0,0.3)',borderRadius:3,width:16,height:16,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,color:'#fff'}} title='Use for spec PDF' onClick={function(e){e.stopPropagation();setHero(i);}}>
                          {isHero?'★':'☆'}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div style={{fontSize:9,color:'#aaa',marginTop:5}}>★ = used for spec PDF  ·  ✓ = included in ZIP</div>
              </div>
            )
            : <div style={{fontSize:11,color:'#aaa',marginBottom:10}}>No images uploaded for this item</div>
          }
          {quoteDocs.length > 0&&(
            <div style={{marginBottom:10,padding:'6px 8px',background:'#e8f5e9',border:'1px solid #c8e6c9',borderRadius:4}}>
              <label style={{display:'flex',alignItems:'center',gap:6,fontSize:11,cursor:'pointer',color:'#2e7d32',fontWeight:600}}>
                <input type='checkbox' checked={includeQuote} onChange={function(e){setIncludeQuote(e.target.checked);}} style={{cursor:'pointer'}} />
                Include vendor quote{quoteDocs.length>1?' ('+quoteDocs.length+' PDFs)':' PDF'}
              </label>
            </div>
          )}
          <div style={{fontSize:11,color:'#888',marginBottom:14,padding:'6px 8px',background:'#f9f9f9',borderRadius:4,lineHeight:1.5}}>
            Includes pricing, tracking &amp; notes
          </div>
          {err&&<div style={{fontSize:11,color:'#c62828',marginBottom:8,padding:'4px 8px',background:'#ffebee',borderRadius:4}}>{err}</div>}
          <button onClick={doExport} disabled={loading} style={{width:'100%',padding:'9px 0',background:'#1a1a1a',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:600,cursor:loading?'not-allowed':'pointer',opacity:loading?0.5:1}}>
            {loading ? 'Generating…' : selectedImgs.length > 0 ? '⬇ Download ZIP  ('+selectedImgs.length+' image'+(selectedImgs.length!==1?'s':'')+')' : '⬇ Download Internal Tear Sheet'}
          </button>
          <div style={{fontSize:9,color:'#bbb',marginTop:8,lineHeight:1.4}}>
            Stable filenames — InDesign relinks automatically on re-export
          </div>
        </div>
      )}
    </div>
  );
}


// ── CLIENT TEAR SHEET BUTTON ─────────────────────────────────────────────────
export function PresentationSpecButton(p) {
  var item = p.item;
  var images = item.images||[];
  var heroIdx = item.heroIndex||0;

  var os = useState(false); var open = os[0]; var setOpen = os[1];
  var hs = useState(heroIdx); var specImgIdx = hs[0]; var setSpecImgIdx = hs[1];
  var ss = useState(images.map(function(_,i){return i;}));
  var selectedImgs = ss[0]; var setSelectedImgs = ss[1];
  var ps = useState(false); var showPricing = ps[0]; var setShowPricing = ps[1];
  var ls = useState(false); var loading = ls[0]; var setLoading = ls[1];
  var es = useState(''); var err = es[0]; var setErr = es[1];

  function toggleImg(i) {
    setSelectedImgs(function(prev) {
      if (prev.indexOf(i) >= 0) {
        if (i === specImgIdx) return prev;
        return prev.filter(function(x){return x!==i;});
      }
      return prev.concat([i]).sort(function(a,b){return a-b;});
    });
  }

  function setHero(i) {
    setSpecImgIdx(i);
    setSelectedImgs(function(prev){
      if (prev.indexOf(i) >= 0) return prev;
      return prev.concat([i]).sort(function(a,b){return a-b;});
    });
  }

  async function doExport() {
    setLoading(true); setErr('');
    try {
      var resolvedComponentPrices=[];
      if(showPricing){
        var markup=parseFloat(String(item.markupPct||30))||30;
        ['Workroom','Hardware'].forEach(function(type){
          var child=(item.children||[]).find(function(c){return c.childType===type;});
          if(!child&&item.assemblyId&&p.allItems){
            child=(p.allItems).find(function(it){return it.assemblyId===item.assemblyId&&it.childType===type;});
          }
          if(!child)return;
          var net=parseFloat(String(child.netPrice||'').replace(/[$,]/g,''))||0;
          if(net>0)resolvedComponentPrices.push({label:type,price:Math.round(net*(1+markup/100)*100)/100});
        });
      }
      var filteredImages = selectedImgs.map(function(i){ return images[i]; }).filter(Boolean);
      var newHeroIdx = selectedImgs.indexOf(specImgIdx);
      await generatePresentationSpec(
        Object.assign({}, item, {images: filteredImages}),
        Math.max(0, newHeroIdx),
        showPricing,
        resolvedComponentPrices
      );
      setOpen(false);
    } catch(e) { setErr(e.message); }
    setLoading(false);
  }

  return (
    <div style={{position:'relative',display:'inline-block'}}>
      <button onClick={function(){setOpen(!open);}} style={{padding:'4px 12px',background:'#1a1a1a',color:'#fff',border:'none',borderRadius:6,fontSize:11,cursor:'pointer'}}>
        ⬇ Client Tear Sheet
      </button>
      {open&&(
        <div style={{position:'absolute',top:'100%',right:0,marginTop:4,background:'#fff',border:'1px solid #e0e0e0',borderRadius:8,padding:16,zIndex:200,width:290,boxShadow:'0 4px 16px rgba(0,0,0,0.12)'}}>
          <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:10}}>
            <div style={{fontSize:11,fontWeight:700,color:'#333'}}>Export Client Tear Sheet</div>
            <button onClick={function(){setOpen(false);setErr('');}} style={{background:'none',border:'none',fontSize:16,color:'#aaa',cursor:'pointer',lineHeight:1}}>×</button>
          </div>
          {images.length > 0
            ? (
              <div style={{marginBottom:14}}>
                <div style={{fontSize:10,fontWeight:700,color:'#888',marginBottom:6,letterSpacing:'0.5px',textTransform:'uppercase'}}>
                  Images — check to include in ZIP, click star for spec
                </div>
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  {images.map(function(img, i) {
                    var isSelected = selectedImgs.indexOf(i) >= 0;
                    var isHero = i === specImgIdx;
                    return (
                      <div key={i} style={{position:'relative',flexShrink:0}}>
                        <div style={{width:56,height:56,borderRadius:4,overflow:'hidden',border:isHero?'2px solid #1a1a1a':isSelected?'2px solid #90caf9':'2px solid #e0e0e0',opacity:isSelected?1:0.4,cursor:'pointer'}} onClick={function(){toggleImg(i);}}>
                          <img src={img.url||''} alt='' style={{width:'100%',height:'100%',objectFit:'cover'}} />
                        </div>
                        <div style={{position:'absolute',bottom:2,left:2,background:isSelected?'#1a56db':'#fff',border:'1.5px solid '+(isSelected?'#1a56db':'#ccc'),borderRadius:3,width:14,height:14,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center'}} onClick={function(e){e.stopPropagation();toggleImg(i);}}>
                          {isSelected&&<span style={{color:'#fff',fontSize:9,lineHeight:1}}>✓</span>}
                        </div>
                        <div style={{position:'absolute',top:2,right:2,background:isHero?'#1a1a1a':'rgba(0,0,0,0.3)',borderRadius:3,width:16,height:16,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',fontSize:9,color:'#fff'}} title='Use for spec PDF' onClick={function(e){e.stopPropagation();setHero(i);}}>
                          {isHero?'★':'☆'}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div style={{fontSize:9,color:'#aaa',marginTop:5}}>★ = used for spec PDF  ·  ✓ = included in ZIP</div>
              </div>
            )
            : <div style={{fontSize:11,color:'#aaa',marginBottom:10}}>No images uploaded for this item</div>
          }
          <label style={{display:'flex',alignItems:'center',gap:8,fontSize:12,cursor:'pointer',marginBottom:14}}>
            <input type='checkbox' checked={showPricing} onChange={function(e){setShowPricing(e.target.checked);}} />
            Include client pricing
          </label>
          {err&&<div style={{fontSize:11,color:'#c62828',marginBottom:8,padding:'4px 8px',background:'#ffebee',borderRadius:4}}>{err}</div>}
          <button onClick={doExport} disabled={loading} style={{width:'100%',padding:'9px 0',background:'#1a1a1a',color:'#fff',border:'none',borderRadius:6,fontSize:12,fontWeight:600,cursor:loading?'not-allowed':'pointer',opacity:loading?0.5:1}}>
            {loading ? 'Generating…' : selectedImgs.length > 0 ? '⬇ Download ZIP  ('+selectedImgs.length+' image'+(selectedImgs.length!==1?'s':'')+')' : '⬇ Download Client Tear Sheet'}
          </button>
          <div style={{fontSize:9,color:'#bbb',marginTop:8,lineHeight:1.4}}>
            Stable filenames — InDesign relinks automatically on re-export
          </div>
        </div>
      )}
    </div>
  );
}
